export default "__VITE_ASSET__C1v7Aymb__"